import _ from 'underscore';

import { odata } from '@bingads-webui/http-util';

const getAccountSettingRepository = ({ aid, cid, oDataConfig }) => ({
  getAccountSettings: (settings) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})?$select=${settings.join(',')}`;
    return odata.get(url, { oDataToken: oDataConfig.oDataToken });
  },
});

export const getAssetEnhancementSettings = ({
  aid, cid, oDataConfig,
}) => {
  const settings = ['AssetAIEnhancementOptout'];
  const accountSettingRepository = getAccountSettingRepository({ aid, cid, oDataConfig });
  return accountSettingRepository.getAccountSettings(settings).then((response) => {
    const pickedSettings = _.pick(response, settings);
    return pickedSettings || {};
  });
};
